import React from 'react';
import TechnologiesSwitcher from '../../../../components/technologies.component';

export const HomeContentMcMakler = props => (
  <div className='check-list-item'>
    <div className='check-list-item-progress'>
      <div className='check-list-item-index'>
      </div>
      <div className='check-list-item-sep'>
      </div>
    </div>
    <div className='check-list-item-body'>
      <p className='title'>
        <b>McMakler GmbH</b> <span><span className='no-mobile'>/ </span>Sep 2018 – Current</span>
      </p>
      <TechnologiesSwitcher>
        <div>
          <p><b>Team Lead Node.js (from September 2019)</b></p>
          <p><b>Senior JavaScript Developer (to September 2019)</b></p>
          <p>I took part at software architect of some projects.</p>
          <p>I was responsible for designing and implementing software.</p>
          <p>I designed and implemented scraping process of some web sites.</p>
          <p>I designed proprietary service-side notification system that integrates with 3rd party software.</p>
          <p>I designed and implemented backend for widget, that is integrated with 3rd party services.</p>
          <p>Improved knowledge at CI/CD. Was writing scripts for automatic deployments</p>
          <p>Improved my knowledge at GraphQL.</p>
          <p>I took part at open source projects.</p>
          <p>Teached and mentored software developers.</p>
          <p>Start learning Go and Rust</p>
        </div>
        <div>
          <div className='project-list'>
            <div className='project-list-item'>
              <div className='project-list-title'>General technologies</div>
              <div
                className='project-list-technologies project-list-technologies--inline'>
                <div>Databases: PostreSQL, MongoDB.</div>
                <div>Web applications, HTML, XML, CSS (scss), client side JavaScript (Angular, React.js).</div>
                <div>Server-side JavaScript: Node.js, Express, Appolo and Nest.js</div>
                <div>VCS (git)</div>
                <div>Build managers: npm, yarn - Node.js.</div>
                <div>Using quick key-value storages like Redis.</div>
                <div>Unix/Linux administration.</div>
                <div>Nginx as front end.</div>
                <div>GitLab Pipelines, CircleCI, Kubernetes</div>
                <div>Docker</div>
                <div>Improved Go knowledge and Rust</div>
              </div>
            </div>
            <div className='project-list-item'>
              <div className='project-list-title'>
                <span>Scraper (for internal usage)</span>
              </div>
              <div
                className='project-list-technologies project-list-technologies--inline'>
                <div>Node.js</div>
                <div>PostgreSQL</div>
                <div>Redis</div>
              </div>
            </div>
            <div className='project-list-item'>
              <div className='project-list-title'>
              <span>Notification service (for internal usage)</span>
              </div>
              <div
                className='project-list-technologies project-list-technologies--inline'>
                <div>Node.js</div>
                <div>PostgreSQL</div>
                <div>Redis</div>
              </div>
            </div>
            <div className='project-list-item'>
              <div className='project-list-title'>
                <span>Widget Backend</span>
              </div>
              <div
                className='project-list-description'>Backend for saving leads to database and processing it to different services (3rd party and internal)
              </div>
              <div
                className='project-list-technologies project-list-technologies--inline'>
                <div>Node.js</div>
                <div>Redis</div>
                <div>MongoDB</div>
              </div>
            </div>
            <div className='project-list-item'>
              <div className='project-list-title'>MCQL</div>
              <div
                className='project-list-description'>Backend fetching data for Angular application using GraphQL
              </div>
              <div
                className='project-list-technologies project-list-technologies--inline'>
                <div>Node.js</div>
                <div>Redis</div>
                <div>Appolo</div>
                <div>GraphQL</div>
              </div>
            </div>
          </div>
        </div>
      </TechnologiesSwitcher>
    </div>
  </div>
);
